var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.5,
    cy: 7.89,
    r: 3.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 4.69,
    cy: 9.96,
    r: 2.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m12.5,13.51c5.19,0,6.72,2.15,7.09,2.91.07.15.11.31.11.47v3.8H5.3v-3.8c0-.16.04-.32.11-.47.38-.76,1.9-2.91,7.09-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m3.1,20.69H0v-2.57c0-2.54,3-3.32,3.99-3.5-1.1,1.1-.98,3.28-.89,6.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 20.31,
    cy: 9.96,
    r: 2.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m21.9,20.69h3.1s0-2.57,0-2.57c0-2.54-3-3.32-3.99-3.5,1.1,1.1.98,3.28.89,6.07Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 25,
    height: 25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.785b747b5e2a83d066d208a46fd9cddb.svg";
export { ForwardRef as ReactComponent };